import { useState } from 'react';

import Cards, { CardFields } from '@/components/HighlightCards/Cards/Cards';
import Tabs from '@/components/HighlightCards/Tabs/Tabs';

import useStyles from './TabbedCards.styles';

type MobileCardsProp = {
  cards: CardFields[];
  isOnDark: boolean;
};

const MobileCards = ({ cards, isOnDark }: MobileCardsProp) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { classes, cx } = useStyles();

  const handleChange = (newValue: number) => {
    setSelectedTab(newValue);
  };

  const tabValues = cards.map((item, index) => ({
    title: item.fields.title,
    value: index,
  }));

  return (
    <div className={classes.wrapper}>
      <div
        className={cx({
          [classes.tabs2up]: cards.length == 2,
          [classes.tabs3up]: cards.length == 3,
        })}
      >
        <Tabs
          clickHandler={handleChange}
          selectedTab={selectedTab}
          tabValues={tabValues}
          isOnDark={isOnDark}
        />
      </div>
      <Cards cards={cards} isOnDark={isOnDark} selectedTab={selectedTab} />
    </div>
  );
};

export default MobileCards;
